import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const MODULE_VERSION_MODULE_DEPENDENCIES_TABLE_STORAGE_KEY =
  "moduleVersionModuleDependenciesTableStorageKey";
export const MODULE_VERSION_PROVIDER_DEPENDENCIES_TABLE_STORAGE_KEY =
  "moduleVersionProviderDependenciesTableStorageKey";

export const MODULE_VERSION_MODULE_DEPENDENCIES_TABLE_FILTERS_STORAGE_KEY =
  "moduleVersionModuleDependenciesTableFiltersStorageKey";
export const MODULE_VERSION_PROVIDER_DEPENDENCIES_TABLE_FILTERS_STORAGE_KEY =
  "moduleVersionProviderDependenciesTableFiltersStorageKey";

export enum MODULE_VERSION_MODULE_DEPENDENCIES_COLUMN_ID {
  NAME = "NAME",
}

export enum MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID {
  NAME = "NAME",
  VERSION = "VERSION",
  SOURCE = "SOURCE",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 2000;

export const MODULE_VERSION_MODULE_DEPENDENCIES_TABLE_COLUMNS_CONFIG: Record<
  MODULE_VERSION_MODULE_DEPENDENCIES_COLUMN_ID,
  TableColumnMeta
> = {
  [MODULE_VERSION_MODULE_DEPENDENCIES_COLUMN_ID.NAME]: {
    id: MODULE_VERSION_MODULE_DEPENDENCIES_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 400,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    // The only column: nothing to hide, pin, move, or resize against.
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
};

export const MODULE_VERSION_PROVIDER_DEPENDENCIES_TABLE_COLUMNS_CONFIG: Record<
  MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID,
  TableColumnMeta
> = {
  [MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.NAME]: {
    id: MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 240,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: false,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.VERSION]: {
    id: MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.VERSION,
    title: "Version",
    minWidth: 100,
    defaultWidth: 120,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.SOURCE]: {
    id: MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.SOURCE,
    title: "Source",
    minWidth: 150,
    defaultWidth: 260,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.DROPDOWN]: {
    id: MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.DROPDOWN,
    title: "Table configuration",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
};

export const MODULE_DEPENDENCIES_SORT_CONFIG: Record<
  MODULE_VERSION_MODULE_DEPENDENCIES_COLUMN_ID,
  string
> = {
  [MODULE_VERSION_MODULE_DEPENDENCIES_COLUMN_ID.NAME]: "name",
};

export const PROVIDER_DEPENDENCIES_SORT_CONFIG: Record<
  MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID,
  string
> = {
  [MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.NAME]: "name",
  [MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.VERSION]: "version",
  [MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.SOURCE]: "source",
  [MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.DROPDOWN]: "dropdown",
};

export const MODULE_DEPENDENCIES_INITIAL_SORT_OPTION =
  MODULE_DEPENDENCIES_SORT_CONFIG[MODULE_VERSION_MODULE_DEPENDENCIES_COLUMN_ID.NAME];
export const PROVIDER_DEPENDENCIES_INITIAL_SORT_OPTION =
  PROVIDER_DEPENDENCIES_SORT_CONFIG[MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.NAME];

export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Asc;
